import type { Signal } from '@angular/core'
import { computed, Injectable, inject } from '@angular/core'
import { EntitySignalQuery } from '@awork/core/state/signal-store/entitySignalQuery'
import type { OnboardingTaskKey } from '@awork/features/onboarding/models/types'
import type { OnboardingTaskProgress } from './onboarding-task-progress.model'
import { OnboardingTaskProgressStore } from './onboarding-task-progress.store'

@Injectable({ providedIn: 'root' })
export class OnboardingTaskProgressQuery extends EntitySignalQuery<OnboardingTaskProgress> {
  protected store: OnboardingTaskProgressStore

  constructor() {
    const store = inject(OnboardingTaskProgressStore)

    super(store)

    this.store = store
  }

  /**
   * Query progress for a specific task by task key
   * @param {OnboardingTaskKey} taskKey
   * @returns {Signal<OnboardingTaskProgress | undefined>}
   */
  queryTaskProgressByKey(taskKey: OnboardingTaskKey): Signal<OnboardingTaskProgress | undefined> {
    return computed(() => {
      const allProgress = this.queryAll({ filterBy: progress => progress.key === taskKey })
      const tasks = allProgress()

      if (tasks.length === 0) {
        return undefined
      }

      return tasks[0]
    })
  }

  /**
   * Query all task progress records
   * @returns {Signal<OnboardingTaskProgress[]>}
   */
  queryAllTaskProgress(): Signal<OnboardingTaskProgress[]> {
    return this.queryAll()
  }

  /**
   * Query completed tasks
   * @returns {Signal<OnboardingTaskProgress[]>}
   */
  queryCompletedTasks(): Signal<OnboardingTaskProgress[]> {
    return this.queryAll({ filterBy: progress => progress.isDone })
  }
}
